import { toMoneyText } from './toMoneyText';

/**
 * This formatter is implemented for covering a particular spec:
 * Money text for arabic locales should have the numbers in English locale but
 * currency shoul be in Arabic locale.
 *
 * Two formatters (one for the number and other for the currency) are used for this task.
 */

const SpecialNumberLocaleFormatter = (
  currencyLocaleFormatter,
  numberLocaleFormatter: {
    format(amount);
  },
  styled
) => ({
  format(amount) {
    const numberLocaleParts = new Map(
      numberLocaleFormatter.format(amount).map((part) => [part?.type, part])
    );
    const currencyLocaleParts = currencyLocaleFormatter.format(amount);
    const moneyParts = currencyLocaleParts.map((part) =>
      part?.type !== 'currency' ? numberLocaleParts.get(part?.type) : part
    );
    if (styled) {
      return moneyParts;
    }
    return [
      {
        type: 'default',
        value: toMoneyText(moneyParts),
      },
    ];
  },
});

export default SpecialNumberLocaleFormatter;
